<template lang="pug">
#inserir-relatorio-rastreabilidade
    BaseHeader#inserir-relatorio-rastreabilidade-header(
        :titulo='$t("mensagens.relatorioRastreabilidade.visualizar.titulo")',
        :exibeBotao='false',
        :voltarPara='true'
    )

    .view-container.margen-bottom-pages
        BlocoVisualizarRelatorio(
            :dadosVisualizarRelatorio='dadosVisualizarRelatorio'
        )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoVisualizarRelatorio from '@/components/relatorioRastreabilidade/BlocoVisualizarRelatorio.vue';
import RelatorioRastreabilidadeService from '@/services/RelatorioRastreabilidadeService';

export default {
    name: 'visualizarRelatorioRastreabilidade',
    props: ['relatorioId'],
    components: {
        BaseHeader,
        BlocoVisualizarRelatorio
    },
    data() {
        return {
            dadosVisualizarRelatorio: {}
        };
    },
    mounted() {
        this.buscarDadosVisualizarRelatorio();
    },

    watch: {
        '$i18n._vm.locale': function () {
            this.buscarDadosVisualizarRelatorio();
        }
    },

    methods: {
        async buscarDadosVisualizarRelatorio() {
            if (!this.relatorioId) {
                this.$router.push({ name: 'RelatorioRastreabilidade' });
                return;
            }
            try {
                const { data } =
                    await RelatorioRastreabilidadeService.buscarResumoRelatorios(
                        this.relatorioId
                    );
                this.dadosVisualizarRelatorio = data.item;
            } catch (error) {
                this.$notify.error({
                    message: 'Erro ao buscar resumo relatórios.'
                });
            }
        }
    }
};
</script>

<style lang="scss">
#inserir-relatorio-rastreabilidade {
    .margen-bottom-pages {
        margin-top: 20px;
    }
    .secao-listagem {
        display: flex;
        margin-top: 20px;
        gap: 25px;
        justify-content: space-between;

        .titulo-listagem h3 {
            font-weight: bold;
        }
    }

    .secao-listagem,
    .bloco-dados-relatorio,
    .bloco-protocolo-relatorio,
    .bloco-consulta-analise-rastreabilidade,
    .bloco-preenchimento-em-lote,
    .bloco-novos-relatorios-tabela {
        margin-top: 20px;
    }

    footer {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .botao-relatorio__remover,
        .botao-relatorio__salvar {
            margin-top: 16px;
            .lyra-icon.lyra-grafico ::after {
                color: white;
            }

            #adicionar-analise {
                span {
                    margin-left: 5px;
                }
            }
        }
    }
}
</style>
